import { userAppPreferencesDefault } from '../../data/user-app-preferences-default';
import {
    UserAppPreferencesModel
} from '../../models/user-app-preferences.model';

/**
 * - Added contactsPrefs
 * - Added generalPrefs with favoriteColors array
 */
export function fromOnePointFiveToOnePointSix(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    const newModel = new UserAppPreferencesModel();
    newModel.version = '1.6';
    newModel.reportsPrefs = oldDataModel.reportsPrefs;
    newModel.targetingPrefs = oldDataModel.targetingPrefs;
    newModel.monitoringPrefs = oldDataModel.monitoringPrefs;

    if (!newModel.contactsPrefs) {
        newModel.contactsPrefs = userAppPreferencesDefault.contactsPrefs;
    }

    newModel.socialPrefs = oldDataModel.socialPrefs;
    newModel.accessibilityPrefs = oldDataModel.accessibilityPrefs;

    if (!newModel.generalPrefs) {
        newModel.generalPrefs = userAppPreferencesDefault.generalPrefs;
    }
    return newModel;
}
